<template>
  <div class="d-flex align-center gap-2" data-testid="notification-header">
    <h3 data-testid="notification-header__title">
      {{ $nova.labelsName('email_notification', 'threshold_label', 'Email Notification') }}s
    </h3>
    <div>
      <v-tooltip bottom content-class="tooltip-bottom">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="shadow-off mr-2"
            icon
            @click="onRefresh"
            data-testid="notification-header__refresh-button"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Refresh</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationHeader",
  methods: {
    onRefresh() {
      this.$emit("refresh");
    },
  },
};
</script>
